import React, { useState, useEffect } from 'react';

const DraggableThemeButton = ({ darkMode, setDarkMode }) => {
  // مواضع الزر الحالية (البداية: أعلى اليمين)
  const [position, setPosition] = useState({ x: window.innerWidth - 70, y: 15 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [hasMoved, setHasMoved] = useState(false);

  // عند بدء السحب (الضغط بالماوس أو اللمس)
  const handleStart = (clientX, clientY) => {
    setIsDragging(true);
    setHasMoved(false);
    setDragOffset({
      x: clientX - position.x,
      y: clientY - position.y
    });
  };

  useEffect(() => {
    const handleMove = (e) => {
      if (!isDragging) return;
      
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      setHasMoved(true);
      setPosition({
        x: clientX - dragOffset.x,
        y: clientY - dragOffset.y
      });
    };

    const handleEnd = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener('mousemove', handleMove);
      window.addEventListener('mouseup', handleEnd);
      window.addEventListener('touchmove', handleMove);
      window.addEventListener('touchend', handleEnd);
    }

    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleEnd);
      window.removeEventListener('touchmove', handleMove);
      window.removeEventListener('touchend', handleEnd);
    };
  }, [isDragging, dragOffset]);

  // تبديل الثيم فقط إذا لم يقم المستخدم بسحب الزر
  const handleClick = () => {
    if (!hasMoved) {
      setDarkMode(!darkMode);
    }
  };

  return (
    <div
      onMouseDown={(e) => handleStart(e.clientX, e.clientY)}
      onTouchStart={(e) => handleStart(e.touches[0].clientX, e.touches[0].clientY)}
      style={{
        position: 'fixed',
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: '42px',
        height: '42px',
        zIndex: 50,
        cursor: isDragging ? 'grabbing' : 'grab',
        userSelect: 'none',
        touchAction: 'none'
      }}
    >
      <button
        onClick={handleClick}
        title={darkMode ? "المظهر الفاتح" : "المظهر الداكن"}
        style={{
          width: '42px',
          height: '42px',
          borderRadius: '50%',
          border: '1px solid ' + (darkMode ? '#374151' : '#e5e7eb'),
          backgroundColor: darkMode ? '#1f2937' : '#ffffff',
          color: darkMode ? '#facc15' : '#4b5563',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '20px',
          cursor: 'inherit',
        }}
      >
        {darkMode ? '☀️' : '🌙'}
      </button>
    </div>
  );
};

export default DraggableThemeButton;